type RouteMap = {
  [key: string]: string;
};
export const routes: RouteMap = {
  form: "/manualaccounts",
  upload: "/upload/:id",
  consent: "/consent",
};
